var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnTitulo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 527.43 83.43",
    style: {
      enableBackground: "new 0 0 527.43 83.43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF003C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "508.9,11.49 157.46,11.49 149.28,3.31 13.38,3.16 3.03,13.52 3.03,58.66 20.93,76.56 399.88,76.56  403.78,80.46 492.76,80.46 496.66,76.56 518.28,76.56 523.87,70.97 523.87,26.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.03,64.41 15.07,76.45 3.03,76.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "151.65,3.31 158.2,9.71 188.11,9.71 181.39,3.31  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTitulo);
export default __webpack_public_path__ + "static/media/btn-titulo.9e4a5484144aa52d97e5ae1a5b0b45f2.svg";
export { ForwardRef as ReactComponent };